// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3JrgB","sendOtp":"AuthorizeToLogin_sendOtp__OVSvv"};